import React, { useState } from 'react';

const LanguageSection = () => {
  const [selectedLanguage, setSelectedLanguage] = useState('');
  const [results, setResults] = useState('');

  const LANGUAGE_API_BASE_URL = 'https://0bldajf14f.execute-api.ap-northeast-2.amazonaws.com/language/genai_foreign_language';

  const languages = [
    { id: 'english', name: '영어' },
    { id: 'japanese', name: '일본어' },
    { id: 'chinese', name: '중국어' }
  ];

  const handleLanguageClick = async (language) => {
    setSelectedLanguage(language);
    setResults('AI가 문장을 생성 중입니다...');

    try {
      const response = await fetch(LANGUAGE_API_BASE_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ language }),
      });

      if (response.ok) {
        const data = await response.json();
        
        // 학습 문장별로 구분하여 포맷팅
        let formattedResults = data.results;
        
        // [학습 문장 1], [학습 문장 2], [학습 문장 3]을 기준으로 문단 나누기
        formattedResults = formattedResults
          .replace(/\[학습 문장 (\d+)\]/g, '<div class="learning-section"><h4>[학습 문장 $1]</h4>')
          .replace(/(\[문장 발음\])/g, '<br><strong>$1</strong><br>')
          .replace(/(\[한글 번역\])/g, '<br><strong>$1</strong><br>')
          .replace(/(\[단어 설명\])/g, '<br><strong>$1</strong><br>')
          .replace(/(\[문법 설명\])/g, '<br><strong>$1</strong><br>')
          .split('<div class="learning-section">')
          .filter(section => section.trim())
          .map(section => `<div class="learning-section">${section}</div>`)
          .join('');

        setResults(`
          <h3>${language.toUpperCase()} 학습 결과</h3>
          <div class="language-learning-content">
            ${formattedResults}
          </div>
        `);
      } else {
        const errorData = await response.json();
        setResults(`에러 발생: ${errorData.message}`);
      }
    } catch (error) {
      console.error('외국어 학습 오류:', error);
      setResults(`서버와 통신 중 오류가 발생했습니다: ${error.message}`);
    }
  };

  return (
    <section className="service-section">
      <h2>외국어 학습 AI 서비스</h2>
      <p className="info-text">(3시간 주기 갱신)</p>
      <div className="button-container">
        {languages.map(language => (
          <button
            key={language.id}
            className={`category-btn ${selectedLanguage === language.id ? 'selected' : ''}`}
            onClick={() => handleLanguageClick(language.id)}
          >
            {language.name}
          </button>
        ))}
      </div>
      {results && <div className="results" dangerouslySetInnerHTML={{ __html: results }}></div>}
    </section>
  );
};

export default LanguageSection;